module.exports = __webpack_public_path__ + "static/media/visa.061f6b24.svg";